import React, { JSX } from "react";
import { Box } from "@mui/material";

// @ts-expect-error - svg
import PoweredByLogo from "../../../../../assets/images/poweredByOkhati1.svg";

const CustomFooterImage = ({
  imageUrl,
  showPoweredByLogo = true
}: {
  imageUrl: string;
  showPoweredByLogo?: boolean;
}): JSX.Element => (
  <Box>
    {showPoweredByLogo && (
      <Box display="flex" justifyContent="flex-end">
        <img
          src={PoweredByLogo}
          alt="logo"
          style={{
            width: "100px",
            height: "33px"
          }}
        />
      </Box>
    )}

    <img
      src={imageUrl}
      alt="custom-footer"
      style={{
        border: "1px dashed #ddd",
        objectFit: "cover",
        width: "100%"
      }}
    />
  </Box>
);

export default CustomFooterImage;
